import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getAzureDataExplorerControls, getReadonlyControl, azureDataExplorerResourceIdFormat, azureDataExplorerResourceIdErrorMessage } from './shared-control-metadata';


export const azureDataExplorerPEMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Kusto/clusters',
    connectionSuffix: 'privateConnections',
    resourceIdValidator: azureDataExplorerResourceIdFormat,
    groupIdMetadata: {
        cluster: {
            linkedServiceType: 'AzureDataExplorer',
            groupId: 'cluster',
            iconClass: 'svg-i-100x100-azure_data_explorer',
            displayName: __IS_FABRIC_DPE__ ? stringResources.AzureDataExplorer_DisplayText : stringResources.AzureDataExplorer_DisplayText_old,
            controls: {
                creationControls: getAzureDataExplorerControls(),
                readonlyControls: getReadonlyControl(azureDataExplorerResourceIdFormat, azureDataExplorerResourceIdErrorMessage)
            }
        }
    }
};
